import {Manhole, Plan} from "types";
import {LidGeometry} from "./lidGeometry";
import {getClosuresIntersectionPositions, getClosureSizes} from "../../../../domain/manhole";

export interface ManholeGeometry {
    physicalClearWidth(): number;
    clearLeft(): number;
    clearRight(): number;
    isClosuresShortSide(): boolean;
    isClosuresLongSide(): boolean;
    rabbetWidth(): number;
    closureThickness(): number;
    closureIntersectionPositions(): number[];
}

export function createManholeGeometry(
    plan: Plan,
    manhole: Manhole,
    scale: number,
    side: string,
    lidGeometry: LidGeometry
): ManholeGeometry {
    const physicalClosureSizes = getClosureSizes(manhole.type);
    const clearLeft = () => {
        return lidGeometry.clearLeft
            + (
                side === 'left' ? plan.width - manhole.y - manhole.height
                    : side === 'right' ? manhole.y
                        : side === 'front' ? manhole.x
                            : side === 'back' ? plan.length - manhole.x - manhole.width
                                : 0
            ) * scale
    }
    const physicalClearWidth = () => {
        return side === 'front' || side === 'back'
            ? manhole.width
            : manhole.height
    }
    const clearWidth = () => physicalClearWidth() * scale
    const clearRight = () => clearLeft() + clearWidth()
    const isClosuresShortSide = () =>
        ((side === 'front' || side === 'back') && manhole.orientation === 'vertical')
        || ((side === 'left' || side === 'right') && manhole.orientation === 'horizontal');

    const closureIntersectionPositions = () =>
        getClosuresIntersectionPositions(physicalClearWidth(), physicalClosureSizes.width)
            .map(p => clearLeft() + p * scale)

    return {
        clearLeft,
        clearRight,
        isClosuresShortSide,
        isClosuresLongSide: () => !isClosuresShortSide(),
        rabbetWidth: () => !!physicalClosureSizes.rabbetWidth ? physicalClosureSizes.rabbetWidth * scale : 0,
        closureThickness: () => physicalClosureSizes.thickness * scale,
        closureIntersectionPositions,
        physicalClearWidth,
    };
}
